import { render, staticRenderFns } from "./ProductProperty.vue?vue&type=template&id=a68c6ad2&scoped=true"
import script from "./ProductProperty.vue?vue&type=script&lang=js"
export * from "./ProductProperty.vue?vue&type=script&lang=js"
import style0 from "./ProductProperty.vue?vue&type=style&index=0&id=a68c6ad2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68c6ad2",
  null
  
)

export default component.exports